
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payrollsystems",
      function () {
        return require("private-next-pages/payrollsystems/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payrollsystems"])
      });
    }
  